module.exports = __webpack_public_path__ + "assets/images/maintenance_illustration.be6b5c295344314c5e9834f71e8f4153.png";